import React from 'react'
import CellBadge from './CellBadge'
import { ICellConfig, ECellColor } from './calendarTypes'

interface IDayCellProps {
  preview?: boolean
  onMouseDown(): void
  onClick(): void
  cellConfigs?: ICellConfig[]
  outsideRangeColor?: ECellColor
  isOutsideRange: boolean
}

const DayCell: React.FC<IDayCellProps> = ({
  preview,
  onMouseDown,
  onClick,
  cellConfigs,
  isOutsideRange,
  outsideRangeColor,
}) => {
  const isDisabled = !!preview || isOutsideRange
  if (!cellConfigs || !cellConfigs.length) {
    return (
      <div
        onMouseDown={() => !isDisabled && onMouseDown()}
        onClick={() => !isDisabled && onClick()}
        className={!isDisabled ? 'dayCell' : 'dayCell-disabled'}
        role="presentation"
        style={{
          backgroundColor: !isOutsideRange
            ? ECellColor.Default
            : outsideRangeColor || ECellColor.OutsideRange,
        }}
      />
    )
  }
  return (
    <div style={{ width: '100%', height: '100%' }} role="presentation">
      {cellConfigs.map((cellConfig, index) => {
        const width = 100 / cellConfigs.length
        const left = (100 / cellConfigs.length) * index
        const outsideColor = outsideRangeColor
          ? outsideRangeColor
          : ECellColor.OutsideRange
        return (
          <React.Fragment key={index}>
            <div
              // TODO: Turn this on again
              // onMouseDown={() => !isDisabled && !cellConfig.disabled && onMouseDown()}
              // className={(!isDisabled && !cellConfig.disabled) ? 'dayCell-child' : 'dayCell-child-disabled'}
              onMouseDown={() => onMouseDown()}
              className={'dayCell-child'}
              style={{
                float: 'left',
                width: `${width}%`,
                height: '100%',
                left: `${left}%`,
                backgroundColor: !isOutsideRange
                  ? cellConfig.color
                  : outsideColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                borderTop:
                  !isOutsideRange && cellConfig.isStart
                    ? `5px solid #ED9E15`
                    : undefined,
                borderBottom:
                  !isOutsideRange && cellConfig.isEnd
                    ? `5px solid #ED9E15`
                    : undefined,
              }}
            >
              <div
                lang="sv"
                className="dayCell-comment"
                style={{
                  backgroundColor: cellConfig.color,
                }}
              >
                {cellConfig?.comment}
              </div>
              {!isOutsideRange &&
                !cellConfig?.disableHover &&
                !cellConfig?.comment &&
                cellConfig?.badge?.contents?.length && (
                  <CellBadge
                    type={cellConfig.badge.type}
                    contents={cellConfig.badge.contents}
                  />
                )}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default DayCell
